import logoWhite from '../../images/logo-white.svg';
import { useTranslation } from "react-i18next";

const Footer = () => {
    const { t } = useTranslation();
    return (
        <footer className="bg-[#52ae30] rounded-t-2xl md:rounded-t-[32px] text-white p-6 md:p-10 mt-auto">
            <div className="max-w-screen-lg mx-auto flex flex-col md:flex-row items-start md:items-center justify-between">

                <a
                    href="https://www.otpbanka.hr/"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="inline-block w-[110px] h-[22px] mb-4 md:mb-0 shrink-0"
                >
                    <img
                        src={logoWhite}
                        alt="OTP Banka Logo"
                        className="w-full h-full object-contain"
                    />
                </a>

                <p className="text-xs sm:text-sm text-center md:text-right">
                    {t("common.footer.description")}
                </p>

            </div>
        </footer>
    );
};

export default Footer;
